import {ChangeDetectionStrategy, Component, Input, TemplateRef} from '@angular/core';
import {ROLL_IN, TURN_OVER} from '../../../shared/animations';
import { NgClass, NgStyle, NgTemplateOutlet } from '@angular/common';

@Component({
    selector: 'app-simple-expansion-panel',
    templateUrl: './simple-expansion-panel.component.html',
    styleUrls: ['./simple-expansion-panel.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    animations: [ROLL_IN, TURN_OVER],
    imports: [NgClass, NgStyle, NgTemplateOutlet]
})
export class SimpleExpansionPanelComponent {
  @Input() title: string;
  @Input() isOpened = false;
  @Input() theme: 'default' | 'dashboard-item' = 'default';
  @Input() titleStyles: Record<string, string>;
  @Input() titleContent: TemplateRef<HTMLElement>;

  /** Contain current panel id. */
  public readonly id = Math.floor(Math.random() * 1000000);
}
